import { EyeOutlined, PrinterOutlined, SelectOutlined } from '@ant-design/icons';
import { DdiziType, OrderDetailType } from '@kinderlabs-pos/shared-data-type';
import {
	AdminProductInfoState,
	DdiziState,
	PosElectronStoreState,
	PrintReceiptState,
	StoreInfoState,
} from '@kinderlabs-pos/state';
import { WithDialog } from '@kinderlabs-pos/ui-atoms';
import { useConfirm } from '@kinderlabs-pos/ui-components';
import { Button, IconButton, List, ListItem, Stack } from '@mui/material';
import { useAtomValue } from 'jotai';
import { DdiziDisplay } from '../../../components/DdiziDisplay';
import { DdiziDetailDialog } from '../../DdiziManagementPage/DdiziDetailDialog';
import { usePosRouter } from '../../routes';
import {
	TicketMappingInfoType,
	바코드총에서얻는티켓매핑Type,
} from 'apps/pos-main/src/modules/mappingTicket/mappingTicketType';
import { MappingTicketApis } from 'apps/pos-main/src/modules/mappingTicket/mappingTicketApis';
import { VaunceDdiziMappingDialog } from 'apps/pos-main/src/modules/order/PrintHandler/VaunceDdiziMappingDialog';
import { useQuery } from '@tanstack/react-query';
import { MappingTicketQuery } from 'apps/pos-main/src/modules/mappingTicket/mappingTicketQuery';

export const DdizListContentsInOrder = ({ order }: { order: OrderDetailType }) => {
	const { navigate퇴장관리 } = usePosRouter();
	const confirm = useConfirm();
	const localSettings = PosElectronStoreState.usePosMainPageLocalSettings().data;
	const handleClick = (ddiziId: string) => () => {
		confirm(`티켓 번호 ${ddiziId} 에 대해 퇴장 관리 화면으로 이동하시겠습니까?`, () => {
			navigate퇴장관리(ddiziId);
		});
	};

	const { storeId, enterpriseId } = useAtomValue(StoreInfoState.curStoreAndDevice);
	const storeInfo = useAtomValue(StoreInfoState.curStoreInfo);
	const { print영수증띠지Async } = PrintReceiptState.useReceiptDdiziPrinter({
		storeId,
		deviceType: 'POS',
	});
	const curDeviceInfo = StoreInfoState.useCurDeviceInfoForOrder();

	const { data: mappingTicketData } = useQuery({
		...MappingTicketQuery.query.mappingTicket.getTicketMappingInfoForOrders(order.id),
		suspense: false,
	});

	const 띠지프린터라벨출력 = PrintReceiptState.LabelPrinter.usePrintLabelPrinter({
		labelPrinterList: curDeviceInfo.labelPrinterList,
	});

	const handlePrinterClick = (ddizi: DdiziType) => () => {
		confirm(`티켓 번호 ${ddizi.id} 를 재발권하시겠습니까?`, async () => {
			const ddiziData = { ...DdiziState.utils.getDdizi인쇄Data(ddizi) };
			let 바코드총데이터: 바코드총에서얻는티켓매핑Type | undefined;
			try {
				if (enterpriseId === 'vaunce')
					바코드총데이터 = mappingTicketData?.find((d) => d.mappedTicketId === ddizi.id);
			} catch {
				// 넘어가
			}

			const 권종 = ddiziData.message.labelName.includes('키즈')
				? '키즈'
				: ddiziData.message.labelName.includes('보호자')
				? '보호자'
				: '일반';

			await 띠지프린터라벨출력({
				...ddiziData,
				meta: 바코드총데이터
					? {
							고객명: 바코드총데이터.name,
							생년월일: 바코드총데이터.birth,
							성별: 바코드총데이터.gender,
							권종,
					  }
					: undefined,
				deviceType: 'POS',
				...PrintReceiptState.LabelPrinter.getDesignOptions({
					localSettings,
					deviceNum: ddiziData.deviceNum,
				}),
				storeName: storeInfo.name,
				modelName:
					curDeviceInfo.labelPrinterList.find((p) => p.logicalName === ddiziData.deviceNum)
						?.modelName ?? '',
			});

			await print영수증띠지Async({
				ddizi,
			});
		});
	};

	return (
		<Stack
			spacing={1}
			sx={{ overflowY: 'auto' }}>
			{enterpriseId === 'vaunce' && (
				<WithDialog
					dialog={(open, closeDialog) => (
						<VaunceDdiziMappingDialog
							open={open}
							closeDialog={closeDialog}
							orderId={order.id}
							ddizis={order.ddizis}
							users={[]}
						/>
					)}>
					{(openDialog) => (
						<Button
							variant={'outlined'}
							onClick={(e) => {
								e.stopPropagation();
								openDialog();
							}}>
							고객 매핑
						</Button>
					)}
				</WithDialog>
			)}
			<List>
				{order.ddizis.map((ddizi, idx) => {
					const 바코드총데이터 = mappingTicketData?.find((d) => d.mappedTicketId === ddizi.id);

					console.log(mappingTicketData, 바코드총데이터, ddizi.id);

					return (
						<ListItem
							key={idx}
							sx={{ px: 0 }}>
							<DdiziDisplay
								sx={{ width: '100%' }}
								key={idx}
								ddizi={ddizi}
								바코드총데이터유저={바코드총데이터?.name}
								userOnPage={'ORDER'}
								itemButton={
									<Stack direction={'row'}>
										<IconButton onClick={handlePrinterClick(ddizi)}>
											<PrinterOutlined style={{ fontSize: 18 }} />
										</IconButton>
										<WithDialog
											dialog={(open, closeDialog) => (
												<DdiziDetailDialog
													open={open}
													closeDialog={closeDialog}
													ddizi={ddizi}
												/>
											)}>
											{(openDialog) => (
												<IconButton onClick={openDialog}>
													<EyeOutlined style={{ fontSize: 18 }} />
												</IconButton>
											)}
										</WithDialog>
										<IconButton onClick={handleClick(ddizi.id)}>
											<SelectOutlined style={{ fontSize: 18 }} />
										</IconButton>
									</Stack>
								}
							/>
						</ListItem>
					);
				})}
			</List>
		</Stack>
	);
};
